import en from './locale-en';
import ru from './locale-ru';

const locales = {
    en,
    ru,
};

export default locales;
